const Embed = () => (
  <>
    <path
      fill="currentColor"
      d="M5 5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 5 5"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 7.5A2.5 2.5 0 0 0 4.5 10v4A2.5 2.5 0 0 0 7 16.5h10a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 17 7.5zm0 1A1.5 1.5 0 0 0 5.5 10v4A1.5 1.5 0 0 0 7 15.5h10a1.5 1.5 0 0 0 1.5-1.5v-4A1.5 1.5 0 0 0 17 8.5z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M5.5 18.5a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1z" />
  </>
)
export default Embed
